/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/customer-condition-checker/app.customer-condition-checker.component.ts.
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppConditionsService} from '../../services/app.conditions.service';
import {Condition} from '../../modules/admin/model/condition';
import {AppPageloaderService} from '../../services/app.pageloader.service';
import {AppGuardsCondition} from '../../guards/app.guards.condition';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject, Subscription} from 'rxjs';
import {AppMessageService} from '../../services/app.message.service';
import {takeUntil} from 'rxjs/operators';

/**
 * Zweck: Beschreibt class AppCustomerConditionCheckerComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'customer-condition-checker',
    templateUrl: 'app.customer-condition-checker.component.html',
    styleUrls: ['app.customer-condition-checker.component.scss'],
    standalone: false
})
export class AppCustomerConditionCheckerComponent implements OnInit, OnDestroy {
  condition: Condition;

  ocsub: Subscription;

  conditionMatchcode: any = null;
  _onDestroy = new Subject<void>();

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: AppConditionsService, private loader: AppPageloaderService, private guard: AppGuardsCondition,
              private router: Router, private route: ActivatedRoute, private msg: AppMessageService) {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this._onDestroy)).subscribe(params => {
      if (params['conditionMatchcode']) {
        this.conditionMatchcode = params['conditionMatchcode'];
      } else {
        this.conditionMatchcode = null;
      }
    });

    this.svc.open_conditions.pipe(takeUntil(this._onDestroy)).subscribe(cs => {
      if (cs) {
        if (this.conditionMatchcode) {
          cs = cs.filter(c => c.matchcode == this.conditionMatchcode);
        }

        if (cs.length > 0) {
          this.condition = cs[0];
        } else {
          const url = this.guard.url_before_redirect;
          if (url != '') {
            this.router.navigateByUrl(url);
          } else {
            this.router.navigateByUrl('/');
          }
        }
      }
    });
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    this.svc.load();
  }


/**
 * Beschreibt Methode accept und ihren Rückgabevertrag.
 */
  accept() {
    const l = this.loader.start();
    this.svc.acceptConditions(this.condition).subscribe(s => {
      this.load();
      l.stop();
    });
  }

/**
 * Beschreibt Methode decline und ihren Rückgabevertrag.
 */
  decline() {
    const l = this.loader.start();
    this.svc.declineConditions(this.condition).subscribe(s => {
      this.load();
      if (this.condition.path_regexes && this.condition.path_regexes.length > 0) {
        this.msg.info('Abgelehnt! Sie werden nun auf das Dashboard umgeleitet.');
        this.router.navigateByUrl('/');
      } else {
        this.msg.info('Abgelehnt!');
        this.router.navigateByUrl('/error/no-agb-accepted');
      }

      l.stop();
    });

  }


}
